import './Icon_Options.css';

function Icon_Options() {
  return (
    <div className='options-icon-container'>
      <div className='options-icon'>
        <svg viewBox="0 0 24 24" className="options-icon-svg">
          <circle cx="12" cy="12" r="1"/>
          <circle cx="12" cy="5" r="1"/>
          <circle cx="12" cy="19" r="1"/>
        </svg>
      </div>
    </div>
  );
}

export default Icon_Options;